import React, { useState } from "react";

const SearchBar = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState("");

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        onSearch(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch(searchTerm);
    };

    return (
        <form onSubmit={handleSubmit} className="w-full">
            <div className="relative flex items-center">
                <div className="absolute left-4 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div>
                <input
                    type="search"
                    value={searchTerm}
                    onChange={handleChange}
                    placeholder="Rechercher un article..."
                    className="w-full h-14 pl-12 pr-4 rounded-xl bg-white text-gray-700 text-base border border-gray-100 focus:outline-none focus:ring-2 focus:ring-purple-400/30 transition-all duration-300"
                    aria-label="Rechercher un article"
                />
            </div>
        </form>
    );
};

export default SearchBar;
